import { mapActions } from 'vuex'
export default {
  async created () {
    if (this.$route.query.recallBySms) {
      return this.$router.push(`/user/login?from=${encodeURIComponent('/middle/auth_result')}`)
    }
    this.getSerialNo()
  },
  mounted () {
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('user', ['getLimitX']),
    async getSerialNo () {
      const { success, data } = await this.getLimitX({ loanPlatform: 'TMD' })
      if (success) {
        if (data.serialNo && ['CREDIT', 'CREDIT_LOCKED', 'CREDIT_REFUSED'].includes(data.creditStatus)) {
          return this.$router.push(`/authentication/result?applyNo=${data.serialNo}`)
        }  
      }
      this.$router.push(`/`)
    }
  },
  render () {
    return <div/>
  }
}